/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskBadRequestError
 */
export interface ExecRiskBadRequestError {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskBadRequestError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskBadRequestError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskBadRequestError
     */
    message: string;
}

/**
 * Check if a given object implements the ExecRiskBadRequestError interface.
 */
export function instanceOfExecRiskBadRequestError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ExecRiskBadRequestErrorFromJSON(json: any): ExecRiskBadRequestError {
    return ExecRiskBadRequestErrorFromJSONTyped(json, false);
}

export function ExecRiskBadRequestErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskBadRequestError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function ExecRiskBadRequestErrorToJSON(value?: ExecRiskBadRequestError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

